exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "*,:after,:before{margin:0;padding:0;box-sizing:inherit}html{font-size:62.5%}h1,h2,h3,h4,h5{margin-block-start:0;margin-block-end:0;font-weight:400}a{text-decoration:none}body{display:flex;justify-content:center;height:100vh;width:100vw;overflow:auto;box-sizing:border-box;font-size:1.6rem}", ""]);

